import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "../app/store";
import { resetAttendanceFilter } from "../features/root/rootSlice";

export default function useFilterReset() {
  const location = useLocation();
  const dispatch = useAppDispatch();

  const pathName = location.pathname;
  const path = pathName.replace(/\/\d+$/, "");

  useEffect(() => {
    if (
      path !== "/admin/attendance/custom-attendance" &&
      path !== "/admin/attendance/custom-attendance/view"
    ) {
      dispatch(resetAttendanceFilter());
    }
  }, [path, dispatch]);

  return undefined;
}
